import clsx from 'clsx';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { TargetPowerSchedule } from './gas-production-target-power-schedule-constraints/TargetPowerSchedule';

interface TargetPowerSchedulePanelProps {
  targetPowerElectric: number | null | undefined;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}
export function TargetPowerSchedulePanel({
  open,
  setOpen,
  targetPowerElectric,
}: Readonly<TargetPowerSchedulePanelProps>) {
  const panelRef = useRef<HTMLDivElement>(null);
  const [panelArea, setPanelArea] = useState({ w: 0, h: 0 });

  useEffect(() => {
    if (panelRef.current) {
      setPanelArea({ w: panelRef.current.clientWidth, h: panelRef.current.clientHeight });
    }
  }, [panelRef]);

  return (
    <div
      className={clsx([
        'fixed top-0 -right-[830px] pointer-events-none transition delay-150 duration-300 ease-in-out bg-white h-full z-[4000] w-1/2 border-box border-solid border border-y-0 pb-4 border-divider opacity-0 overflow-scroll',
        { '-translate-x-[1200px] opacity-100 pointer-events-auto': open },
      ])}
      ref={panelRef}
    >
      <TargetPowerSchedule
        //mocked data
        targetPowerSchedule={new Map([400, 420, 400, 370, 350, 600, 600].entries())}
        panelArea={panelArea}
        targetPowerElectric={targetPowerElectric}
      />
    </div>
  );
}
